import React from 'react';
import { HeartPulseIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-4 pb-28 pt-8 text-center sm:pb-10" data-id="element-167" data-mp="207t2wbhjjpmm">
      <div className="mx-auto w-full max-w-2xl border-t border-white/10 pt-8" data-id="element-168" data-mp="209x9502wx0q2">
        <div className="inline-flex items-center gap-2" data-id="element-169" data-mp="2f2qydd7zkv7x">
          <HeartPulseIcon className="h-4 w-4 text-brandred" aria-hidden="true" data-id="element-170" data-mp="2a5gwuz7bot3q" />
          <span className="text-sm font-extrabold text-white" data-id="element-171" data-mp="1mfmoatu1dqpa">Dra. Karito</span>
        </div>
        <p className="mt-3 text-xs leading-relaxed text-white/50" data-id="element-172" data-mp="1hhbg0nje3o96">
          Ruta Hipertensión es un material educativo dirigido a profesionales de la
          salud. No sustituye el juicio clínico ni la relación médico-paciente.
        </p>
        <p className="mt-4 text-xs text-white/40" data-id="element-173" data-mp="1reh7vxztvjag">
          © {new Date().getFullYear()} Dra. Karito · Todos los derechos reservados
        </p>
      </div>
    </footer>;
}